import React, { useState } from 'react';
import Card from '../../../components/base/Card';
import Button from '../../../components/base/Button';
import {
  calculateDiagnosisResultPath,
  diagnosisQuestionsV3,
  diagnosisScaleLabels,
} from '@/data/diagnosisQuestionsV3';

export default function DiagnosisForm() {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [answers, setAnswers] = useState<Record<number, number>>({});

  const questions = diagnosisQuestionsV3;

  const handleAnswerSelect = (questionId: number, choiceIndex: number) => {
    setAnswers(prev => ({ ...prev, [questionId]: choiceIndex }));
  };

  const handleNext = () => {
    if (currentQuestion < questions.length - 1) {
      setCurrentQuestion(prev => prev + 1);
    }
  };

  const handlePrevious = () => {
    if (currentQuestion > 0) {
      setCurrentQuestion(prev => prev - 1);
    }
  };

  const handleSubmit = () => {
    const resultPage = calculateDiagnosisResultPath(answers);
    window.REACT_APP_NAVIGATE(resultPage);
  };

  const progress = ((currentQuestion + 1) / questions.length) * 100;
  const currentQ = questions[currentQuestion];
  const isAnswered = answers[currentQ.id] !== undefined;
  const isLastQuestion = currentQuestion === questions.length - 1;
  const selectedIndex = answers[currentQ.id];

  return (
    <Card className="p-8 bg-white/95 backdrop-blur-sm">
      {/* Progress Bar */}
      <div className="mb-8">
        <div className="flex justify-between items-center mb-2">
          <span className="text-sm font-medium text-[#6B7280]">
            質問 {currentQuestion + 1} / {questions.length}
          </span>
          <span className="text-sm font-medium text-[#6B7280]">
            {Math.round(progress)}% 完了
          </span>
        </div>
        <div className="w-full bg-gray-200 rounded-full h-2">
          <div
            className="bg-gradient-to-r from-[#02D0F0] to-[#07DBCA] h-2 rounded-full transition-all duration-300"
            style={{ width: `${progress}%` }}
          ></div>
        </div>
      </div>

      {/* Question */}
      <div className="mb-12">
        <h2 className="text-2xl font-bold text-[#111827] mb-8 leading-relaxed text-center">
          {currentQ.question}
        </h2>

        {/* Scale Options */}
        <div className="max-w-2xl mx-auto">
          <div className="flex flex-col gap-3">
            {diagnosisScaleLabels.map((label, index) => (
              <button
                key={index}
                onClick={() => handleAnswerSelect(currentQ.id, index)}
                className={`p-4 text-center rounded-xl border-2 transition-all duration-200 ${
                  selectedIndex === index
                    ? 'border-[#02D0F0] bg-[#02D0F0]/10 text-[#02D0F0] shadow-md'
                    : 'border-gray-200 hover:border-[#02D0F0]/50 hover:bg-[#02D0F0]/5'
                }`}
              >
                <div className="flex items-center justify-center">
                  <div className={`w-5 h-5 rounded-full border-2 mr-3 flex items-center justify-center flex-shrink-0 ${
                    selectedIndex === index
                      ? 'border-[#02D0F0] bg-[#02D0F0]'
                      : 'border-gray-300'
                  }`}>
                    {selectedIndex === index && (
                      <div className="w-2 h-2 rounded-full bg-white"></div>
                    )}
                  </div>
                  <span className="font-medium">{label}</span>
                </div>
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Navigation */}
      <div className="flex justify-between items-center">
        <Button
          variant="outline"
          onClick={handlePrevious}
          disabled={currentQuestion === 0}
          className={currentQuestion === 0 ? 'opacity-50 cursor-not-allowed' : ''}
        >
          <i className="ri-arrow-left-line mr-2"></i>
          前の質問
        </Button>

        {isLastQuestion ? (
          <Button
            onClick={handleSubmit}
            disabled={!isAnswered}
            className={!isAnswered ? 'opacity-50 cursor-not-allowed' : ''}
          >
            診断結果を見る
            <i className="ri-arrow-right-line ml-2"></i>
          </Button>
        ) : (
          <Button
            onClick={handleNext}
            disabled={!isAnswered}
            className={!isAnswered ? 'opacity-50 cursor-not-allowed' : ''}
          >
            次の質問
            <i className="ri-arrow-right-line ml-2"></i>
          </Button>
        )}
      </div>
    </Card>
  );
}
